export default "__VITE_ASSET__Dqip3sIm__"